interface DataTableShellProps {
  title?: string;
  toolbar?: React.ReactNode;
  children: React.ReactNode;
  /** Inside `.panel` on download pages — no extra border; allows sticky thead. */
  embedded?: boolean;
}

export function DataTableShell({
  title,
  toolbar,
  children,
  embedded = false,
}: DataTableShellProps) {
  return (
    <div
      className={
        embedded
          ? "bg-[var(--surface)]"
          : "overflow-hidden rounded-lg border border-[var(--border)] bg-[var(--surface)]"
      }
    >
      {title || toolbar ? (
        <div className="flex flex-wrap items-center justify-between gap-2 border-b border-[var(--border)] px-4 py-3">
          {title ? <strong className="text-sm text-[var(--text)]">{title}</strong> : null}
          {toolbar}
        </div>
      ) : null}
      {embedded ? children : <div className="overflow-x-auto">{children}</div>}
    </div>
  );
}

export const tableClass =
  "w-full min-w-[640px] border-collapse text-left text-sm";

export const thClass =
  "border-b border-[var(--border)] bg-[var(--surface-2)] px-4 py-2 text-xs font-semibold text-[var(--muted)]";

export const tdClass = "border-b border-[var(--border-soft)] px-4 py-3 align-middle";
